import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { paths } from '@/routes/paths';
import { IcHome, IcTravel, IcBusiness, IcSettings } from '@/components/ui/icons';
import styles from './BottomTabs.module.css';

// 4 tabs from Figma bottom-nav (General / Travel / Business / Settings).
// Wallet and Notifications are accessed from Home top-bar shortcuts.

interface Tab {
  to: string;
  label: string;
  icon: JSX.Element;
  matches: (pathname: string) => boolean;
}

export function BottomTabs(): JSX.Element {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const tabs: Tab[] = [
    {
      to: paths.home,
      label: t('nav.home'),
      icon: <IcHome />,
      matches: (p) => p.startsWith(paths.home) || p === '/' || p.startsWith('/booking'),
    },
    {
      to: paths.travel,
      label: t('nav.travel'),
      icon: <IcTravel />,
      matches: (p) => p.startsWith(paths.travel),
    },
    {
      to: paths.business,
      label: t('nav.business'),
      icon: <IcBusiness />,
      matches: (p) => p.startsWith(paths.business),
    },
    {
      to: paths.settings,
      label: t('nav.settings'),
      icon: <IcSettings />,
      matches: (p) => p.startsWith(paths.settings),
    },
  ];

  return (
    <nav className={styles.dock} aria-label="Primary">
      <ul className={styles.list}>
        {tabs.map((tab) => {
          const active = tab.matches(pathname);
          return (
            <li key={tab.to} className={styles.item}>
              <NavLink
                to={tab.to}
                className={`${styles.link} ${active ? styles.active : ''}`}
                aria-current={active ? 'page' : undefined}
              >
                <span className={styles.icon}>{tab.icon}</span>
                {active && <span className={styles.label}>{tab.label}</span>}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
